import { Paper, Text, Table, Badge, Flex, Progress, Accordion, Box } from "@mantine/core";
import { IconSchool } from "@tabler/icons-react";

function conversionColor(rate) {
    if (rate >= 20) return "green";
    if (rate >= 10) return "yellow";
    return "red";
}

/**
 * Breakdown del embudo por capacitación.
 * Se muestra dentro de un Accordion cuando no hay una capacitación específica seleccionada.
 */
export default function FunnelAUBreakdown({ byAcademicUnit }) {
    if (!byAcademicUnit || byAcademicUnit.length === 0) return null;

    const maxTotal = Math.max(...byAcademicUnit.map((au) => au.totalLeads), 1);

    return (
        <Accordion variant="contained" radius="md">
            <Accordion.Item value="breakdown">
                <Accordion.Control>
                    <Flex align="center" gap="sm">
                        <IconSchool size={18} />
                        <Box>
                            <Text fw={600} size="sm">Embudo por capacitación</Text>
                            <Text size="xs" c="dimmed">
                                {byAcademicUnit.length} capacitaciones en el período
                            </Text>
                        </Box>
                    </Flex>
                </Accordion.Control>
                <Accordion.Panel>
                    <div style={{ overflowX: "auto" }}>
                        <Table withTableBorder withColumnBorders highlightOnHover>
                            <Table.Thead>
                                <Table.Tr>
                                    <Table.Th style={{ width: 220, maxWidth: 220 }}>Capacitación</Table.Th>
                                    <Table.Th ta="center" style={{ width: 80 }}>Total</Table.Th>
                                    <Table.Th style={{ minWidth: 90 }}>Proporción</Table.Th>
                                    <Table.Th ta="center" style={{ width: 90 }}>En proceso</Table.Th>
                                    <Table.Th ta="center" style={{ width: 90 }}>Convertidos</Table.Th>
                                    <Table.Th ta="center" style={{ width: 80 }}>Perdidos</Table.Th>
                                    <Table.Th ta="center" style={{ width: 90 }}>Conversión</Table.Th>
                                </Table.Tr>
                            </Table.Thead>
                            <Table.Tbody>
                                {byAcademicUnit.map((au) => (
                                    <Table.Tr key={au._id}>
                                        <Table.Td style={{ maxWidth: 220 }}>
                                            <Text size="sm" fw={500} lineClamp={2} title={au.auName}>
                                                {au.auName}
                                            </Text>
                                        </Table.Td>
                                        <Table.Td ta="center">
                                            <Text size="sm" fw={600}>{au.totalLeads}</Text>
                                        </Table.Td>
                                        <Table.Td>
                                            <Progress
                                                value={maxTotal > 0 ? (au.totalLeads / maxTotal) * 100 : 0}
                                                size="sm"
                                                color="blue"
                                            />
                                        </Table.Td>
                                        <Table.Td ta="center">
                                            <Text size="sm" c="yellow.7">{au.inProgress}</Text>
                                        </Table.Td>
                                        <Table.Td ta="center">
                                            <Text size="sm" c="green.7">{au.converted}</Text>
                                        </Table.Td>
                                        <Table.Td ta="center">
                                            <Text size="sm" c="red.6">{au.lost}</Text>
                                        </Table.Td>
                                        <Table.Td ta="center">
                                            <Badge
                                                color={conversionColor(au.conversionRate)}
                                                variant="light"
                                                size="sm"
                                            >
                                                {au.conversionRate}%
                                            </Badge>
                                        </Table.Td>
                                    </Table.Tr>
                                ))}
                            </Table.Tbody>
                        </Table>
                    </div>
                </Accordion.Panel>
            </Accordion.Item>
        </Accordion>
    );
}
